<template>
    <div>
        <div class="modal-container">

            <!-- 

            <div class="modal-body">
                {{message}}
                <div class="body-bott">
                    <button class="button is-warning" @click="$emit('close')">
                        OK
                    </button>
                </div>
            </div>

            <div class="modal-footer">
                <div>

                </div>
            </div> -->

         

            <div class="">
                <button class="delete is-pulled-right top5 right5" @click="$emit('close')"></button>
                <br>
                <div class="theMessage" v-html="message"></div>
                <div class="body-bott has-text-centered">
                    <button class="button is-yell" @click="$emit('close')">
                            OK
                    </button>
                </div>
                <br>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {message: String}
}
</script>

<style scoped>
    .modal-container{
        width: 350px;
        min-height: 250px;
        border-top: 8px solid #ffcb57;
        border-radius: 15px;
        overflow: hidden;
        padding: 10px;
        background: #103858;  /* fallback for old browsers */
       /*background: -webkit-linear-gradient(to right, #000f46, #21496b );  /* Chrome 10-25, Safari 5.1-6 */
        /*background: linear-gradient(to right, #000f46, #21496b);  W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    }
    
    .notification{
        height: 100%;
    }
    .theMessage{
        padding: 10px;
        border-bottom-left-radius: 10px;
        margin-bottom: 10px;
        background-color: #0a2540;
        border-left: 4px solid #50abc7
    }

    .modal-header{
        height: 15px;
        background-color: #21346b
    }

</style>



// WEBPACK FOOTER //
// src/components/ModalOK.vue